export default {
  SECTION_WIDGET_INTERACTIVE: {
    container: {
      cellWidth: {
        100: {
          allow: true,
        },
        66.67: {
          allow: true,
        },
        58.33: {
          allow: true,
        },
        50: {
          allow: true,
        },
        41.67: {
          allow: true,
        },
        33.33: {
          allow: true,
        },
        25: {
          allow: true,
        },
        20: {
          allow: true,
        },
        16.66: {
          allow: true,
        },
      },
    },
    fluid: {
      cellWidth: {
        100: {
          allow: true,
        },
        66.67: {
          allow: true,
        },
        58.33: {
          allow: true,
        },
        50: {
          allow: true,
        },
        41.67: {
          allow: true,
        },
        33.33: {
          allow: true,
        },
        25: {
          allow: true,
        },
        20: {
          allow: true,
        },
        16.66: {
          allow: true,
        },
      },
    },
  },
};
